export type DeliveryStatus = "sent" | "failed";

export interface MailStatusInfo {
  status: DeliveryStatus;
  lobStatus: string;
}

export interface FaxStatusInfo {
  status: DeliveryStatus;
  errorDetails?: string;
}

export function mapLobStatusToDeliveryStatus(
  lobStatus: string,
): DeliveryStatus {
  const statusLower = lobStatus.toLowerCase();

  if (
    statusLower === "returned to sender" ||
    statusLower === "failed" ||
    statusLower === "rejected"
  )
    return "failed";

  return "sent";
}

export function mapFaxStatusToDeliveryStatus(
  faxStatus: string,
): DeliveryStatus {
  const statusLower = faxStatus.toLowerCase();

  if (statusLower === "send_failed" || statusLower === "initiation_failed") {
    return "failed";
  }

  return "sent";
}

export function formatAddressForDisplay(
  address:
    | {
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        state: string;
        zip: string;
      }
    | null
    | undefined,
): string | null {
  if (!address) return null;

  const parts = [
    address.addressLine1,
    address.addressLine2,
    address.city && address.state
      ? `${address.city}, ${address.state} ${address.zip ?? ""}`
      : null,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(" ") : null;
}

export function normalizeFaxNumber(fax: string | null | undefined): string {
  if (!fax) return "";
  return fax.replace(/\D/g, "");
}
